export default function ResponsiveImage({ src, alt, width, height, className, loading = "lazy", fetchPriority, dataTestid }) {
  const webp = src.replace(/\.(png|jpe?g)$/i, ".webp");
  return (
    <picture>
      <source srcSet={webp} type="image/webp" />
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding="async"
        className={className}
        data-testid={dataTestid}
      />
    </picture>
  );
}
